import React from "react";
import Alert from "@atlas/uicorn/lib/Data/Alert";
import InfoIcon from "@atlas/uicorn/lib/Icon/InfoIcon";
import Text from "@atlas/uicorn/lib/Display/Text";
import ArrowIcon from "@atlas/uicorn/lib/Icon/ArrowIcon";
import t from "../../../texts/t";
import styles from "../../../styles/login-alert.module.css";

function LoginAlert({ language, loginUrl }: TLoginAlertProps) {
  return (
    <Alert
      className={styles.alert}
      icon={<InfoIcon />}
      message={
        <div className={styles.message}>
          <Text>
            {t("If you are a customer, login to view your tickets.", language)}
          </Text>
          <a href={loginUrl} className={styles.link}>
            {t("Login", language)}
            <ArrowIcon dir="up-right" />
          </a>
        </div>
      }
    />
  );
}

export default LoginAlert;

// #region Types

type TLoginAlertProps = {
  language?: string;
  loginUrl: string;
};

// #endregion
